@if (isMobile()=== false) {
<div class="variants-container" [attr.aria-labelledby]="'subcategory-label'" tabindex="-1" role="radiogroup">
    <span id="subcategory-label" class="sr-only">{{ selectedVtoSubcategory.localizedVtoSubcategoryType }}</span>
    <div
        #noVariant
        role="radio"
        [attr.aria-checked]="!hasVariant"
        [attr.aria-labelledby]="'no-shade'"
        class="icon-container"
        [tabIndex]="hasVariant ? -1 : 0"
        (keydown)="keydownNoVariant($event)"
        [class.checked-vto-variant]="selectedVtoSubcategory.selectedSkuVariant === NO_SHADE"
        (click)="selectVtoVariant.emit(NO_SHADE)">
        <h-svg-icon [name]="'circle-ban'"></h-svg-icon>
        <span id="no-shade" class="sr-only" i18n="@@hermes.product-page.vto-no-shade">No shade selected</span>
    </div>
    @for (product of selectedVtoSubcategory.vtoProducts; track trackByVariantItems(index, product); let index = $index)
    {
    <h-virtual-try-on-variant-item
        #variantsItems
        [index]="index"
        [isDesktop]="true"
        [product]="product"
        [titleAlignment]="getTitleAlignment(index + 2)"
        [selected]="selectedVtoSubcategory.selectedSkuVariant === product.sku"
        (focusItemIndex)="focusAndClick($event)"
        (selectItemSku)="selectVtoVariant.emit(product.sku)"></h-virtual-try-on-variant-item>
    }
</div>
} @else {
<div class="mobile-slider-container">
    <div class="icon-selector"></div>
    <h-carousel
        #carousel
        [spaceBetween]="16"
        [slidesPerView]="'auto'"
        [isSimulateTouchEnabled]="true"
        [preloadImages]="false"
        [lazyLoadingOptions]="{ loadPrevNext: false }"
        [carouselWrapperCustomCSS]="{position: 'relative',height: '80px',}"
        [a11yOptions]="{ enabled: true, slideRole: 'listitem', }"
        [isControlsDisplayed]="false"
        [centeredSlides]="true"
        [appearance]="'variant'"
        [carouselPaginationOptions]="false"
        [slideToClickedSlide]="true"
        [slideTo]="slideTo() ?? -1"
        [isMobile]="isMobile()"
        [watchSlidesProgress]="false"
        (slideChangeTransitionEnd)="slideChangeTransitionEnd($event)"
        [flexCenterSlide]="true"
        [initialSlide]="initialSlide">
        <div
            #noVariant
            role="radio"
            [tabIndex]="selectedVtoSubcategory.selectedSkuVariant === 'NO_SHADE' ? 0 : -1"
            class="icon-container"
            (keydown)="keydownVariantNoShade($event)"
            *hSlide>
            <h-svg-icon [name]="'circle-ban'"></h-svg-icon>
        </div>
        @for (product of selectedVtoSubcategory.vtoProducts; track trackByVariantItems(index, product); let index =
        $index) {

        <h-virtual-try-on-variant-item
            #variantsItems
            [isDesktop]="false"
            [product]="product"
            [selected]="selectedVtoSubcategory.selectedSkuVariant === product.sku"
            (slidePrev)="slideToPosition($event, -1)"
            (slideNext)="slideToPosition($event, 1)"
            [index]="index"
            *hSlide></h-virtual-try-on-variant-item>

        }
    </h-carousel>
</div>
}
